import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  useToast,
} from '@chakra-ui/react'
import { api } from '../../../../services/api'
import { useMutation } from 'react-query'

async function confirmJ3(nunota) {
  const response = await api.get(`${process.env.REACT_APP_BASE_URL}/site/v2/tracken/fechar-pedido-tracken/${nunota}`)

  return response.data
}

export function ModalJ3({ nunota, refresh }) {
  const toast = useToast({
    position: 'top',
  })

  const { data, mutateAsync, isLoading } = useMutation({
    mutationFn: confirmJ3,
    mutationKey: 'confirmJ3',
  })

  async function handleConfirmJ3() {
    try {
      await mutateAsync(nunota)
      toast({
        title: 'J3 solicitada com sucesso!',
        status: 'success',
        duration: 9000,
        isClosable: true,
      })

      /*    refresh({
        codigo_parceiro: '',
        numero_pedido: '',
        data_entrada: '',
        data_saida: '',
        pendente: '',
        nfe: ''
      });
    */
    } catch (error) {
      toast({
        title: 'Erro ao solicitar J3!',
        description: error.response.data.erros,
        status: 'error',
        duration: 9000,
        isClosable: true,
      })
    }
  }

  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <>
      <Button onClick={onOpen} colorScheme="blue" ml="2" size="sm">
        J3
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>J3</ModalHeader>
          <ModalCloseButton />
          <ModalBody>Você está prestes a solicitar a J3, deseja continuar?</ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button colorScheme="blue" isLoading={isLoading} onClick={handleConfirmJ3} loadingText="Solicitando...">
              Continuar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
